<template>
  <div>
    <Preloader />

    <NuxtLayout :name="layout">
      <NuxtPage
        :transition="{ name: 'page-fade', mode: 'out-in', appear: false }"
        @transitionstart="onTransitionStart"
      />
    </NuxtLayout>

    <div class="snackbars" id="form-output-global"></div>
  </div>
</template>

<script setup>
const route = useRoute();

const layout = computed(() => {
  return route.meta?.layout ?? "default";
});

const onTransitionStart = () => {
  bootstrapTemplate();
};

onMounted(() => {
  bootstrapTemplate();
});

useHead({
  meta: [{ name: "robots", content: "index, follow" }],
  meta: [
    {
      name: "google-site-verification",
      content: "kzjyQtDx16MwJs1Mh-GLCFEUebzEKbX47TjvDeINEDg",
    },
  ],
});
</script>
